/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Force_Render_All_AudioInputs */

const en_force_render_all_audio = /** @type {(inputs: Force_Render_All_AudioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Force Render ALL Audio...`)
};

const fr_force_render_all_audio = /** @type {(inputs: Force_Render_All_AudioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Forcer le rendu de TOUT l'audio...`)
};

const de_force_render_all_audio = /** @type {(inputs: Force_Render_All_AudioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alle Audiodateien erzwingen...`)
};

const it_force_render_all_audio = /** @type {(inputs: Force_Render_All_AudioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Forza il rendering di TUTTI gli audio...`)
};

const ru_force_render_all_audio = /** @type {(inputs: Force_Render_All_AudioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Принудительное воспроизведение всего звука...`)
};

const es_force_render_all_audio = /** @type {(inputs: Force_Render_All_AudioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Forzar renderizado de TODO el audio...`)
};

const zh_cn2_force_render_all_audio = /** @type {(inputs: Force_Render_All_AudioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`强制渲染所有音频...`)
};

const ja_force_render_all_audio = /** @type {(inputs: Force_Render_All_AudioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`すべてのオーディオを強制的にレンダリング...`)
};

const hi_force_render_all_audio = /** @type {(inputs: Force_Render_All_AudioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सभी ऑडियो को जबरदस्ती रेंडर करें...`)
};

const pt_pt2_force_render_all_audio = /** @type {(inputs: Force_Render_All_AudioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Forçar renderização de TODO o áudio...`)
};

/**
* | output |
* | --- |
* | "Force Render ALL Audio..." |
*
* @param {Force_Render_All_AudioInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const force_render_all_audio = /** @type {((inputs?: Force_Render_All_AudioInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Force_Render_All_AudioInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_force_render_all_audio(inputs)
	if (locale === "de") return de_force_render_all_audio(inputs)
	if (locale === "it") return it_force_render_all_audio(inputs)
	if (locale === "ru") return ru_force_render_all_audio(inputs)
	if (locale === "es") return es_force_render_all_audio(inputs)
	if (locale === "zh-CN") return zh_cn2_force_render_all_audio(inputs)
	if (locale === "ja") return ja_force_render_all_audio(inputs)
	if (locale === "hi") return hi_force_render_all_audio(inputs)
	if (locale === "pt-PT") return pt_pt2_force_render_all_audio(inputs)
	return en_force_render_all_audio(inputs)
});